import React from 'react';
import { Typography, Divider, Price } from 'fronton-react';
import { WarningIcon } from '@fronton/icons-react';
import { Cart } from '../Cart';
import { useTotalPrices } from '../../hooks/use-total-prices';
import { useRegionMismatch } from './hooks/use-region-mismatch';
import { AddToCartWrapper, ResultSumWrapper, PriceResultClassname, RegionMismatchContainer } from './styles';

export const AddToCart = () => {
  const {
    mainProductTotalPrice,
    isShowComplementaryProductsTotalPrice,
    complementaryProductsTotalPrice,
    totalPrice,
  } = useTotalPrices();
  const { isRegionMismatch } = useRegionMismatch();

  return (
    <AddToCartWrapper data-testid="add-to-cart">
      <ResultSumWrapper>
        <Typography size="body_short" variant="s" color="text-primary">
          Основной товар
        </Typography>
        <Price
          align="right"
          size="s"
          value={mainProductTotalPrice}
          variant="regular"
          className={PriceResultClassname}
          fraction
        />
      </ResultSumWrapper>
      {isShowComplementaryProductsTotalPrice ? (
        <ResultSumWrapper>
          <Typography size="body_short" variant="s">
            Расходники и инструменты
          </Typography>
          <Price
            align="right"
            size="s"
            value={complementaryProductsTotalPrice}
            variant="regular"
            className={PriceResultClassname}
            fraction
          />
        </ResultSumWrapper>
      ) : null}

      <Divider orientation="horizontal" variant="line" />
      <ResultSumWrapper isLast>
        <Typography size="body_accent" variant="l">
          Итого
        </Typography>
        <Price
          align="right"
          size="xl"
          value={totalPrice}
          variant="medium"
          data-testid="calculation-price"
          fraction
        />
      </ResultSumWrapper>
      {isRegionMismatch ? (
        <RegionMismatchContainer>
          <WarningIcon type="fill" size="s" color="attention-primary" />
          <Typography size="caption" variant="minor" color="text-secondary">
            Расчёт был сделан в другом регионе. Цены в корзине могут измениться
          </Typography>
        </RegionMismatchContainer>
      ) : null}
      <Cart />
    </AddToCartWrapper>
  );
};
